import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';

const LargeUserImageAvatar = ({ testId, className })=>{
    return /*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: className,
        "data-testid": testId,
        children: [
            /*#__PURE__*/ jsx("rect", {
                width: "24",
                height: "24",
                fill: "#E0E0E0"
            }),
            /*#__PURE__*/ jsx("circle", {
                cx: "12",
                cy: "9",
                r: "4.5",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M3 21.75C3 18.0221 6.02208 15 9.75 15H14.25C17.9779 15 21 18.0221 21 21.75V24H3V21.75Z",
                fill: "#FAFAFA"
            })
        ]
    });
};

export { LargeUserImageAvatar as default };
